<div class="container-fluid">
  <main role="main">
    <div class="container-fluid">
      <div class="col-12">
        <div class="card p-4 text-center">
          <div class="card-body">
            <!-- Centered illustration via external link -->
            <img
              src="https://stories.freepiklabs.com/storage/8167/404-Error_Mesa-de-trabajo-1.svg"
              alt="404 Not Found"
              class="img-fluid mb-4"
              style="max-width: 300px" />
            <h1 class="card-title text-danger mb-3">404 - Page Not Found</h1>
            <p class="text-muted mb-4">Oops! The page you're looking for doesn't exist or has been moved.</p>
            <a routerLink="/dashboard" class="btn btn-primary btn-enjochem">
              <i class="bi bi-house-door me-2"></i>
              Go to Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
